export default "__VITE_ASSET__201yuw5R__"